export default "__VITE_ASSET__C4Fb2JSu__"